<form DraggableDialog [formGroup]="form" (ngSubmit)="submit()">
  <div style="height:80px">
    <span mat-dialog-title class="title">Läs in schema från Heroma</span>
  </div>

  <span class="sub-title">Datum</span>

  <mat-dialog-content style="height:100px">
    <div class="row">
      <div class="col-7" style="display: flex; justify-content: center; ">
        <mat-form-field appearance="outline" style="border: none; border-radius: 0px; width: 330px;">
          <input matInput formControlName="dateFormControl" style="font-size: 20px"
                 [matDatepicker]="importDatePicker" (click)="importDatePicker.open()">

          <mat-datepicker-toggle matSuffix [for]="importDatePicker">
            <mat-icon class="icon-display" matDatepickerToggleIcon>
              calendar_month
            </mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #importDatePicker>
          </mat-datepicker>
        </mat-form-field>

      </div>
      <div class="col-5" style="display: flex; justify-content: center;">
        <button mat-button type="button" style="background: #2D6E78; border-radius: 0px; color: white; width: 180px; height:50px; font-size: 16px; margin-top: 5px;" (click)="import()" [disabled]="importing">
          Läs in
        </button>
      </div>

    </div>
  </mat-dialog-content>
  <div style="display: flex; justify-content: center">
    <mat-spinner *ngIf="importing"></mat-spinner>
  </div>
  
  <div style="border-bottom: 2px solid #0F1A41; width: 100%; margin-left:2px; margin-bottom: 20px; margin-top: 10px;"></div>

  <div style="display: flex;flex-direction:row-reverse;margin-bottom:15px">
    <button mat-button type="button" mat-dialog-close style="background:transparent;border-color:grey;color:grey;border-style:solid;border-width:1px; width:180px; height: 50px;" [disabled]="importing">
      Stäng
    </button>
  </div>
</form>
